/**
 * Component: M27 Feature Card
 * 
 */
'use strict';

export class FeatureCard
{
  constructor()
  {
    this.selectors = {
      component:    $('.c-v4-m27-feature-card'),
      sliders:      $('.c-v4-m27-feature-card--slider'),
      current_page: $('.c-v4-m27-feature-card--slider-pager span.current'),
    };
  }

  init()
  {
    if ( ! this.selectors.component.length ) return;

    this.init_slick_carousel();
  }

  init_slick_carousel()
  {
    let _self = this;

    this.selectors.sliders.each(function()
    {
      $(this).on('beforeChange', function( event, slick, currentSlide, nextSlide )
      {
        _self.selectors.current_page.html( nextSlide + 1 );
      });

      $(this).slick({
        infinite:       true,
        slidesToScroll: 1,
        slidesToShow:   1,
        prevArrow:      $('.c-v4--slick-arrow-left'),
        nextArrow:      $('.c-v4--slick-arrow-right'),
      });
    });
  }
}